import { useContext } from "react";
import { simulatorContext } from "../../service/SimulatorContext";

export default function Disclaimer() {
    const { stockMarket } = useContext(simulatorContext);


    return (
        <div className="disclaimer-desktop">
            <div>* ידוע לי כי אין באמור כאן משום התחייבות כלשהי וכי הסכומים המאושרים הם אלו שיופיעו בהסכם ההצטרפות הרשמי מטעם הגמ"ח.</div>
            {(!!stockMarket.enabled) && <>
                <div>* רווחי שוק ההון מחושבים לפי ריבית נומינלית עבור חלק השנים השלמות כמקובל, ועבור יתרת החודשים לפי ריבית יחסית של יתרת החודשים.</div>
                <div>* ריבית ההלוואה הבנקאית מחושבת לפי ריבית אפקטיבית כמקובל</div>
            </>
            }

        </div>
    )
}
